import React from 'react';
import Flex from '@wix/da-ds/pkg/Flex';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import TierPricePerMonth from '../TierPricePerMonth';
import s from './TierPriceWithBadge.scss';
const TierPriceWithBadge = ({ price , showPlaceholder , className  })=>{
    return /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center",
        className: className
    }, /*#__PURE__*/ React.createElement(PromoBadge, {
        badgeType: "tier",
        size: 24,
        className: s['badge']
    }), showPlaceholder && !price ? /*#__PURE__*/ React.createElement("span", {
        className: s['placeholder']
    }) : /*#__PURE__*/ React.createElement(TierPricePerMonth, {
        price: price
    }));
};
TierPriceWithBadge.displayName = 'TierPriceWithBadge';
export default TierPriceWithBadge;
